import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';

import { ENABLED_TRANSLATE_LANGUAGES } from 'utils/config';

import en from './en/translation.json';
import jp from './jp/translation.json';
import ko from './ko/translation.json';
import { convertLanguageJsonToObject } from './translations';
import zh_cn from './zh_cn/translation.json';
import zh_tw from './zh_tw/translation.json';

//zh_CN
//zh_WT
const avalableTranslationsJson = {
  ja: {
    translation: jp,
    label: '日本語',
  },
  en: {
    translation: en,
    label: 'English',
  },
  ko: {
    translation: ko,
    label: '한국어',
  },
  'zh-CN': {
    translation: zh_cn,
    label: '简体中文',
  },
  'zh-TW': {
    translation: zh_tw,
    label: '繁體中文',
  },
};

export const translationsJson = Object.keys(avalableTranslationsJson).reduce((acc, key) => {
  if (ENABLED_TRANSLATE_LANGUAGES.includes(key)) {
    acc[key] = avalableTranslationsJson[key];
  }
  return acc;
}, {});

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(jp);

const getConfiguredLangByI18nLang = i18nLang => {
  if (i18nLang === 'zh-CN') {
    return 'zh_cn';
  }
  if (i18nLang === 'zh-TW') {
    return 'zh_tw';
  }
  if (i18nLang === 'auto') {
    return 'ja';
  }
  return i18nLang;
};

export const keyExisted = (i18nLang, key) => {
  const langObjToCheck = translationsJson[i18nLang].translation;
  return !!langObjToCheck[key];
};

const getGTranslateLang = () => {
  var keyValue = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)');
  return keyValue ? keyValue[2].split('/')[2] : null;
};

// const getI18nLangByConfiguredLang = configuredLanguage => {
//   if (configuredLanguage === 'zh_cn') {
//     return 'zh-CN';
//   }
//   if (configuredLanguage === 'zh_tw') {
//     return 'zh-TW';
//   }
//   return configuredLanguage;
// };

// const userLanguage = getI18nLangByConfiguredLang(getGTranslateLang());
export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: translationsJson,
    fallbackLng: ENABLED_TRANSLATE_LANGUAGES[0],
    //debug: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
